export const opr_search_param = {
  base_from_date: "",
  base_to_date: "",
  branch_info: {
    branch_id: "",
    branch_name: "",
  },
  combo_selector: {
    branch_list: [[""]],
    hq_list: [""],
    target_list: [
      {
        branch_list: [
          {
            branch_id: "",
            branch_name: "",
          },
        ],
        hq_info: {
          hq_id: "",
          hq_name: "",
        },
      },
    ],
  },
  hq_info: {
    hq_id: "",
    hq_name: "",
  },
};
